import ListCreditScoreByEmployeesBox from './ListCreditScoreByEmployeesBox'

export default ListCreditScoreByEmployeesBox
